export class CodeTypeModel{
    public ID:string;
    public Code:string;
    public Name:string;
    public constructor(){
        this.ID="";
        this.Code="";
        this.Name="";
    }
}